import { useState } from 'react';
import { deleteMenuPermission } from '../../helpers/api_helper';
import { useSelector } from 'react-redux';

const useDeleteMenuPermission = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const deleteMenuPermissionHook = async (menu_id, role) => {
        setLoading(true);
        setError(null);
        try {
            const response = await deleteMenuPermission(menu_id, role, tenantId);
            return response;
        } catch (err) {
            const errorMessage = `Failed to delete menu permission: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { deleteMenuPermission: deleteMenuPermissionHook, loading, error };
};

export default useDeleteMenuPermission;